import React from 'react';
import { Upload, Mail, AlertCircle } from 'lucide-react';
import Card from '../components/ui/Card';
import CardContent from '../components/ui/CardContent';
import Layout from '../components/Layout';

const UploadPage = () => {
  const uploadMethods = [
    {
      title: "Email",
      description: "Отправьте материалы на email",
      details: "Oleg.platov.04@mail.ru\nМаксимальный размер: 25MB",
      icon: <Mail className="w-6 h-6" />
    },
    {
      title: "Облачное хранилище",
      description: "Загрузите файлы и отправьте ссылку",
      details: "Google Drive, Яндекс.Диск, Dropbox",
      icon: <Upload className="w-6 h-6" />
    },  
  ];

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Как отправить материалы</h1>
        
        <div className="mb-8 bg-blue-50 p-4 rounded-lg flex items-start space-x-3">
          <AlertCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold mb-2">Требования к материалам:</h3>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
              <li>Фото: JPG, PNG, RAW</li>
              <li>Видео: MP4, MOV, AVI</li>
              <li>Минимальное разрешение фото: 3000x2000px</li>
              <li>Минимальное разрешение видео: 1920x1080px</li>
            </ul>
          </div>
        </div>

        <div className="grid gap-6">
          {uploadMethods.map((method, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    {method.icon}
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold mb-2">{method.title}</h2>
                    <p className="text-gray-600 mb-2">{method.description}</p>
                    <pre className="text-sm text-gray-500 whitespace-pre-wrap">{method.details}</pre>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default UploadPage;